import { action, computed, observable, set } from "mobx";

class TourStatistic {
  /**
   * @property {number}
   */
  @observable tourId = 0;

  /**
   * @property {string}
   */
  @observable coCustomerPhoto = "";

  /**
   * @property {string}
   */
  @observable customerPhoto = "";

  /**
   * @property {number}
   */
  @observable firstTimeVisits = 0;

  /**
   * @property {string}
   */
  @observable posterImage = "";

  /**
   * @property {number}
   */
  @observable posterImageHeight = 0;

  /**
   * @property {number}
   */
  @observable posterImageWidth = 0;

  /**
   * @property {number}
   */
  @observable posterImageXOffset = 0;

  /**
   * @property {number}
   */
  @observable posterImageYOffset = 0;

  /**
   * @property {string}
   */
  @observable providerLogo = "";

  /**
   * @property {number}
   */
  @observable repeatVisits = 0;

  @observable topImagesLifetime = [];

  @observable topReferrers = [];

  /**
   * @property {number}
   */
  @observable totalImageViewsLifetime = 0;

  /**
   * @property {number}
   */
  @observable totalLifetimeImageViews = 0;

  /**
   * @property {number}
   */
  @observable totalLifetimeTourViews = 0;

  /**
   * @property {number}
   */
  @observable totalLifetimeVisitors = 0;

  /**
   * @property {number}
   */
  @observable totalReferredViews = 0;

  /**
   * @property {number}
   */
  @observable totalViewsLast7Days = 0;

  /**
   * @property {number}
   */
  @observable totalViewsLast8Weeks = 0;

  @observable viewsLast7Days = [];

  @observable viewsLast8Weeks = [];

  constructor(tourId, data) {
    this.tourId = tourId;
    if (data !== undefined) {
      this.setData(data);
    }
  }

  @computed
  get totalImagesViewedPerVisitor() {
    if (this.totalLifetimeVisitors === 0) {
      return 0;
    }

    return (this.totalLifetimeImageViews / this.totalLifetimeVisitors).toFixed(1);
  }

  @action
  setData(data) {
    set(this, data);
  }
}
export default TourStatistic;
